import React from 'react';

const MainPageSeparator = ({list}) => {
    return (
        <div className="main__separator">
            <div className="main__separator-item"></div>
            <div className="main__separator-item"></div>
            <div className="main__separator-item"></div>
            <div className="main__separator-item"></div>
        </div>
    );
};

export default MainPageSeparator;



// WEBPACK FOOTER //
// ./src/components/main-page/MainPageSeparator.js